import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import api from "../../axiosConfig";

export default function SursaEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ descriere: "" });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get(`/sursa/${id}`)
      .then((res) => {
        if (alive) {
          setForm({ descriere: res.data?.descriere ?? "" });
          setLoading(false);
        }
      })
      .catch((err) => {
        alert("Eroare la încărcare: " + (err.response?.data?.detail || err.message));
        setLoading(false);
      });
    return () => { alive = false; };
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await api.put(`/sursa/${id}`, form);
      navigate("/sursa");
    } catch (err) {
      alert("Eroare la actualizare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null; // sau un spinner

  return (
    <Container className="mt-4">
      <Card className="p-3">
        <h3>Editare Sursă #{id}</h3>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Denumire sursă</Form.Label>
                <Form.Control
                  type="text"
                  name="descriere"
                  value={form.descriere ?? ""}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="text-end">
            <Button type="submit" disabled={submitting}>Salvează</Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
}
